module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAD6SURBVEhL1ZNPjgFBGEd7IUNmbCyYsXMI17C0cxErYiOZnau4x0wk/oVE7MTeAXi/6EoqlaKarl70S17oj3pfaJIy8ImN+9N41HCIO7ymnvEX65iLb1ygCbv+oT7VWzRxiQrtcYDH9Np2gi9jx/Woa9FBd8kBX6KFK9ThLf6gjW/JB2bCFx+l2rhLqhhEN3SNbtxE3CV91FyLgoTicowVFF3Ujdd8qsEzFNtgKK65Xrfn//iFD3k3fsEZBv9o5lDWuHlfZkzIHFIwWlyYmI3CUeLCt0BEidvft02UuDihWeAzV1zM0ReWuePC/cVEp4eFxUUbC4uXkSS5ASlTilQiG8JAAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-stanley-knife/dark/24.png
// module id = 2476
// module chunks = 2